<template>
<div id="view-message" class="container">
    <h3>View Messages</h3>
    
    <form>
        <div class="form-group login">
        <input id="email" type="email"  v-model="email" class="form-control" placeholder="Your email" required>
       <br>
        <input id="password" type="password" class="form-control" v-model="password" placeholder="Your password" required>
       <br>
        
        <button v-on:click="login" type="submit" class="btn btn-primary">Login</button>
        </div>
      </form>
      
</div>
</template>

<script>
import firebase from 'firebase'
export default {
   name: 'view-message',
    data: function (){
        return {
           email: '',
           password: ''
        };
    },
    methods: {
        login: function(e){
            firebase
            .auth()
            .signInWithEmailAndPassword(this.email, this.password)
            .then(
                user => {
                    alert(`you have loggedIn as ${user.email}`)
                     this.$router.push('/dashboard');
                },
                err => {
                    alert(err.message)
                }
            );
            e.preventDefault();
        }

    }
}
</script>




// WEBPACK FOOTER //
// src/components/ViewMessage.vue